import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	defaultErrorMessage: {
		id: 'jira-navigation-apps-sidebar-nav4-projects-customise-order.default-error-message',
		defaultMessage: 'Check your connection and try again.',
		description:
			'Flag description informing the user that setting their navigation customisation preference has failed.',
	},
	defaultErrorTitle: {
		id: 'jira-navigation-apps-sidebar-nav4-projects-customise-order.default-error-title',
		defaultMessage: "We couldn't update your view.",
		description:
			'Flag title informing the user that setting their navigation customisation preference has failed.',
	},
});
